import * as actions from "../constants/actionTypes";
import * as utils from "../utils/utils";
import * as utilsPort from "../utils/port";

const initialState = {
    ports: [],
    loading: false,
    saving: false,
    deleting: false
};

export default function ports(state = initialState, action) {
    let newState = Object.assign({}, state);

    switch (action.type) {
        case actions.LOADING_PORT:
            newState.loading = true;
            break;

        case actions.SAVING_PORT:
            newState.saving = true;
            break;

        case actions.RECEIVED_PORTS:
            newState.ports = utils.mapById(utilsPort.flattenCountry(action.payload));
            newState.loading = false;
            break;

        case actions.SAVED_PORT:
            let found = false;

            for (let i = 0; i < newState.ports.length; i++) {
                if(newState.ports[i].id === action.payload.id){
                    found = true;

                    newState.ports[i] = action.payload;
                }
            }

            if(!found) {
                newState.ports.add(
                    action.payload
                );
            }

            newState.ports = utils.mapById(utilsPort.flattenCountry(newState.ports));
            newState.loading = false;
            newState.saving = false;
            break;

        case actions.ERROR_SAVING_PORTS:
            newState.loading = false;
            newState.saving = false;
            break;

        case actions.DELETING_PORT:
            newState.deleting = true;
            break;

        case actions.DONE_DELETING_PORT:
            newState.deleting = false;
            break;

        default: break;
    }

    return newState;
}



// WEBPACK FOOTER //
// ./src/reducers/port.js